import React from 'react';
import { normDateToAmericanDateTime } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { observer } from 'mobx-react-lite';
import DocumentTag from 'components/common/documents-upload/DocumentTag';
import DocumentStatusIcon from 'components/common/documents-upload/DocumentStatusIcon';

import { DocumentStatus, Uploader } from 'types/documentsService';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  CardStyled,
  CardHeaderStyled,
  CardTitleStyled,
  CardBodyStyled,
  TopSectionStyled,
  InfoHeadingStyled,
  InfoDescriptionStyled,
} from './styles';

interface DocumentCardBasicProps {
  type: string;
  status: DocumentStatus;
  uploader: Uploader | null;
  description: string;
  actionDropdown?: React.ReactNode;
}

interface DocumentTitleProps {
  type: string;
  status: DocumentStatus;
}

export interface DocumentInfoBlockProps extends ICustomizableElement {
  label: string;
  value: string;
}

export const DocumentTitle: React.FC<DocumentTitleProps> = observer(({ type, status }) => {
  return (
    <CardTitleStyled>
      <DocumentStatusIcon status={status} />
      {type}
    </CardTitleStyled>
  );
});

export const DocumentInfoBlock: React.FC<DocumentInfoBlockProps> = observer(({ label, value, className }) => {
  return (
    <div className={className}>
      <InfoHeadingStyled>{label}</InfoHeadingStyled>
      <InfoDescriptionStyled>{value}</InfoDescriptionStyled>
    </div>
  );
});

const DocumentCardBasic: React.FC<DocumentCardBasicProps> = observer(
  ({ type, status, uploader, description, actionDropdown }) => {
    return (
      <CardStyled $status={status}>
        <CardHeaderStyled>
          <DocumentTitle type={type} status={status} />
          <DocumentTag status={status} />
        </CardHeaderStyled>
        <CardBodyStyled>
          <TopSectionStyled>
            <DocumentInfoBlock
              label="Uploaded By"
              value={
                uploader
                  ? `${uploader?.name}, ${normDateToAmericanDateTime(uploader?.creationDateTime)}`
                  : '--Not Uploaded--'
              }
            />
            {actionDropdown || null}
          </TopSectionStyled>
          {description ? <DocumentInfoBlock label="Description" value={description} /> : null}
        </CardBodyStyled>
      </CardStyled>
    );
  },
);

export default DocumentCardBasic;
